import { http } from './http'

export async function getWorkload({ dateFrom, dateTo } = {}) {
  const params = {}
  if (dateFrom) params.date_from = dateFrom
  if (dateTo) params.date_to = dateTo
  const { data } = await http.get('chpo/workload/', { params })
  return data
}
